import {
	Carousel,
	ChevronLeftIcon,
	ChevronRightIcon,
} from "@au-schein-de/au-ui-library";
import type { EmblaCarouselType } from "embla-carousel";
import { useCallback, useEffect, useState } from "react";
import {
	EXCLUSIVE_CAROUSEL_NAV_BUTTON_CLASS,
	EXCLUSIVE_CAROUSEL_NAV_ICON_CLASS,
} from "./exclusive-carousel-nav-button-styles";
import {
	isExclusiveCarouselScrollable,
	scrollExclusiveCarouselNext,
	scrollExclusiveCarouselPrev,
} from "./exclusive-carousel-navigation";

interface ExclusiveCarouselNavigationProps {
	api: EmblaCarouselType | undefined;
}

export function ExclusiveCarouselNavigation({
	api,
}: ExclusiveCarouselNavigationProps) {
	const [isScrollable, setIsScrollable] = useState(false);
	const updateScrollable = useCallback(() => {
		setIsScrollable(isExclusiveCarouselScrollable(api));
	}, [api]);
	useEffect(() => {
		if (!api) {
			return;
		}
		updateScrollable();
		api.on("reInit", updateScrollable);
		api.on("select", updateScrollable);
		api.on("scroll", updateScrollable);
		return () => {
			api.off("reInit", updateScrollable);
			api.off("select", updateScrollable);
			api.off("scroll", updateScrollable);
		};
	}, [api, updateScrollable]);
	if (!isScrollable) {
		return null;
	}
	return (
		<div className="flex w-[88px] shrink-0 justify-end gap-2 md:w-auto">
			<Carousel.Previous
				disabled={false}
				className={EXCLUSIVE_CAROUSEL_NAV_BUTTON_CLASS}
				onClick={() => {
					if (api) {
						scrollExclusiveCarouselPrev(api);
					}
				}}
				icon={
					<ChevronLeftIcon.Raw className={EXCLUSIVE_CAROUSEL_NAV_ICON_CLASS} />
				}
			/>
			<Carousel.Next
				disabled={false}
				className={EXCLUSIVE_CAROUSEL_NAV_BUTTON_CLASS}
				onClick={() => {
					if (api) {
						scrollExclusiveCarouselNext(api);
					}
				}}
				icon={
					<ChevronRightIcon.Raw className={EXCLUSIVE_CAROUSEL_NAV_ICON_CLASS} />
				}
			/>
		</div>
	);
}
